module.exports = __webpack_public_path__ + "static/media/Sorghum6-7.2adb6c3a.PNG";